import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEchartsCore } from 'ngx-echarts';
import { routes } from './app.routes';
import { jwtInterceptor } from './core/auth/jwt.interceptor';
import { companyInterceptor } from './core/auth/company.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([jwtInterceptor, companyInterceptor])),
    provideAnimations(),
    // AA-75 (épica AA-16 · M5): import perezoso de echarts -- evita que el bundle de ECharts
    // (los charts.module de ngx-echarts) se cargue hasta que algún componente use <div echarts>.
    provideEchartsCore({ echarts: () => import('echarts') })
  ]
};
